// removed by extract-text-webpack-plugin
module.exports = {"bg":"yw3AT","base":"_3EU-N","sectionHeader":"_3fdm0","title":"_1j_8c","content":"sYT1C","spinner":"_2M5AN","list":"_27r6j","fieldset":"_3LvuP","form":"_1CVpw","group":"_1I16e","footer":"_3myM-"};


//////////////////
// WEBPACK FOOTER
// ./src/views/AccountsAndLoans/LockedAccountDisplayForm.scss
// module id = 2493
// module chunks = 0